import { Grid } from '@mui/material';
import Container from '@mui/material/Container';
import AppContainer from 'src/components/appComponents/AppContainer';
import AppLoadingAndErrorWrapper from 'src/components/appComponents/AppLoadingAndErrorWrapper';
import { useSettingsContext } from 'src/components/settings';
import { useGetParentSuggestionByIdQuery } from 'src/graphql';
import { useParams } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import ParentSuggestionsButtons from 'src/sections/parentSuggestions/ParentSuggestionsButtons';
import ParentSuggestionsInfo from 'src/sections/parentSuggestions/ParentSuggestionsInfo';

export default function ParentSuggestionsDetailsPage() {
  const settings = useSettingsContext();
  const { suggestedId } = useParams();

  const { data: suggestionVideo, isLoading: isLoadingGetSuggestionVideo } =
    useGetParentSuggestionByIdQuery({
      id: suggestedId,
    });

  const routeLinksWithoutExtensionUserId = [
    { name: 'Parent Suggestions' },
    // {
    //   name: 'Suggestions',
    //   href: `${paths.dashboard.parentSuggestions.suggestions}`,
    // },
    {
      name: 'View',
    },
  ];

  return (
    <>
      <AppLoadingAndErrorWrapper isLoading={isLoadingGetSuggestionVideo}>
        {/* Video Info */}
        <AppContainer pageTitle="View" routeLinks={routeLinksWithoutExtensionUserId}>
          <Grid container spacing={2}>
            <ParentSuggestionsInfo
              suggestion={suggestionVideo?.app_suggested_by_pk}
              type={suggestionVideo?.app_suggested_by_pk?.type == 'video' ? 'Video' : 'Channel'}
            />
          </Grid>
        </AppContainer>

        {/* Buttons */}
        <Container maxWidth={settings.themeStretch ? false : 'xl'}>
          <ParentSuggestionsButtons suggestion={suggestionVideo?.app_suggested_by_pk} />
        </Container>
      </AppLoadingAndErrorWrapper>
    </>
  );
}
